import {combineReducers} from 'redux';

import * as actionTypes from './actionTypes';

const initialState = {
    selectedSerie: null,
    selectedSeason: null,
    selectedEpisode: null
};

const reducer = combineReducers({

    selectedSerie: (state = initialState.selectedSerie, action) => {
        switch (action.type) {
            case actionTypes.UPDATE_SELECTED_SERIE:
                return action.serie;
            default:
                return state;
        }
    },

    selectedSeason: (state = initialState.selectedSeason, action) => {
        switch (action.type) {
            case actionTypes.UPDATE_SELECTED_SEASON:
                return action.season;
            case actionTypes.UPDATE_VIEW_EPISODE:
                if(state?.season_number == null)
                    return state;
                return {
                    ...state, episodes: state.episodes.map(x => {
                        if (x.id === action.episode.id) {
                            return {...x, view: action.view, view_date: action.view ? new Date().toISOString() : null};
                        } else {
                            return x;
                        }
                    })
                }
            default:
                return state;
        }
    },

    selectedEpisode: (state = initialState.selectedEpisode, action) => {
        switch (action.type) {
            case actionTypes.UPDATE_SELECTED_EPISODE:
                return action.episode;
            case actionTypes.UPDATE_VIEW_EPISODE:
                return {...state, view: action.view, view_date: action.view ? new Date().toISOString() : null};
            default:
                return state;
        }
    }
});

export default reducer;
